<!--
 * @Author: LeeHuiXian
 * @version: 
 * @Date: 2020-04-26 14:15:50
 * @LastEditors: Please set LastEditors
 * @LastEditTime: 2023-10-31 15:22:00
 * @FilePath: /goldenSalesMobile/src/views/UsersOrder/index.vue
 * @Description: 用户订单列表
-->
<template>
  <div class="page-container">
    <div class="tab-list">
      <van-tabs
        v-model="activeTabName"
        swipeable
        sticky
        color="var(--tc)"
        title-active-color="var(--tc)"
        title-inactive-color="#666666"
        @change="onTabChange"
      >
        <van-tab
          v-for="(item, index) in tabList"
          swipeable
          :key="index"
          :title="item.title"
          :name="item.statusCode"
          :swipe-threshold="5"
        >
          <van-list
            v-model="loading"
            :error.sync="loadError"
            :finished="finished"
            :offset="30"
            error-text="请求失败，点击重新加载"
            finished-text="没有更多了"
            @load="onLoad"
          >
            <div
              class="order-item"
              v-for="(subItem, subIndex) in item.orderList"
              :key="subIndex"
              @click="onCheckDetail(subItem.Id, subItem.Status.Id)"
            >
              <div class="first-line">
                <span>订单号：{{ subItem.Id }}</span>
                <span :class="'status-style-' + subItem.Status.Id">
                  <a>{{ subItem.Status.Name }}</a>
                </span>
              </div>
              <div class="second-line">
                <p v-for="detail in subItem.Details" :key="detail.Id">
                  {{ detail.ProductShelfName }} X {{ detail.Quantity }}
                </p>
              </div>
              <div class="last-line">
                <span v-if="subItem.PayTime"
                  >付款时间：{{ subItem.PayTime }}</span
                >
                <span>￥{{ subItem.Receipts }}</span>
              </div>
              <div class="option-btn">
                <van-button
                  v-if="subItem.IsAllowRefund && subItem.Status.Id === 1"
                  type="default"
                  size="small"
                  round
                  @click.stop="onRefund(subItem.Id)"
                >
                  申请退款
                </van-button>
              </div>
            </div>
          </van-list>
        </van-tab>
      </van-tabs>
    </div>
  </div>
</template>

<script>
import { getUserOrderList } from "@/api/order";
export default {
  data() {
    return {
      loading: false,
      loadError: false,
      finished: false,
      activeTabName: "",
      tabList: [
        {
          title: "全部",
          statusCode: "",
          orderList: [],
        },
        {
          title: "待付款",
          statusCode: 0,
          orderList: [],
        },
        {
          title: "待使用",
          statusCode: 1,
          orderList: [],
        },
        {
          title: "已取消",
          statusCode: 2,
          orderList: [],
        },
      ],
      pageIndex: 0,
      pageSize: 10,
    };
  },

  created() {},

  methods: {
    // 上拉加载
    // TODO tab切换之后上拉加载为何会连续触发
    onLoad() {
      // console.log('上拉加载销售订单')
      this.pageIndex++;
      this.getSalesOrders();
    },

    // 加载订单列表
    getSalesOrders() {
      getUserOrderList({
        query: { Status: this.activeTabName },
        pager: { pageindex: this.pageIndex, pagesize: this.pageSize },
      })
        .then((res) => {
          // console.log(res)
          let data = res.Items;
          if (data instanceof Array) {
            // 判断订单是否支持退款
            data.map((subItem) => {
              subItem.IsAllowRefund = subItem.Details.some(
                (innerItem) => innerItem.ProductIsAllowRefund
              );
            });
            // 把订单数据填充到对应的tabList中
            this.tabList.map((item) => {
              if (item.statusCode === this.activeTabName) {
                if (this.pageIndex > 1) {
                  item.orderList = item.orderList.concat(data);
                } else {
                  item.orderList = data;
                }
                // console.log(data)
              }
            });
            // 没有更多数据时结束上拉加载事件
            if (data.length < this.pageSize || data.length === 0) {
              this.finished = true;
            }
            // 加载结束
            this.loading = false;
          }
        })
        .catch((err) => {
          // console.log(err)
          this.loadError = true;
          this.loading = false;
        });
    },

    // tab切换
    onTabChange(val) {
      this.finished = false;
      this.loading = true;
      this.activeTabName = val;
      this.pageIndex = 0;
      this.getSalesOrders();
    },

    // 查看订单详情
    onCheckDetail(orderId, orderStatusCode) {
      if (orderStatusCode !== 2 && orderStatusCode !== 0) {
        // 除了已取消和待支付的订单其他状态订单才可以查看消费码
        this.$router.push({
          name: "ConsumeCode",
          params: { id: orderId },
        });
      }
    },

    // 申请退款
    onRefund(orderId) {
      this.$router.push({
        name: "RefundApplication",
        params: {
          id: orderId,
        },
      });
    },
  },
};
</script>

<style lang="scss" scoped>
.page-container {
  background: $blockBgColor;

  .tab-list {
    margin-bottom: 100px;

    &::v-deep .van-list {
      @include border-box(0 20px);
    }

    .order-item {
      width: 100%;
      box-shadow: 0px 0px 14px 0px rgba(182, 182, 182, 0.5);
      border-radius: 16px;
      margin-top: 20px;
      overflow: hidden;

      > div {
        @include border-box(0 20px);
      }

      .first-line {
        @include flex-box(space-between);
        height: 84px;
        border-bottom: 1px solid #f7f7f7;

        > span:first-child {
          line-height: 40px;
          font-size: 28px;
          font-weight: 500;
          color: $secondFontColor;
        }

        > span:last-child {
          width: 112px;
          height: 34px;
          line-height: 34px;
          text-align: center;
          font-size: 24px;
          font-weight: 500;
          color: #fff;
          border-radius: 8px;
          transform: skewX(-30deg);

          > a {
            display: inline-block;
            transform: skewX(30deg);
          }

          &.status-style-0 {
            // 待付款
            background: linear-gradient(to right, #fa9b00, #fbca39);
          }

          &.status-style-1 {
            // 待使用
            background: linear-gradient(
              to right,
              rgb(99, 238, 81),
              rgb(113, 233, 123)
            );
          }

          &.status-style-2 {
            // 已取消
            background: linear-gradient(to right, #b5bbd0, #d7ddea);
          }

          &.status-style-3 {
            // 退款中
            background: linear-gradient(
              to right,
              rgb(142, 164, 245),
              rgb(149, 180, 247)
            );
          }

          &.status-style-4 {
            // 已退款
            background: linear-gradient(
              to right,
              rgb(241, 73, 73),
              rgb(240, 99, 134)
            );
          }

          &.status-style-5 {
            // 已完成
            background: linear-gradient(to right, #b5bbd0, #d7ddea);
          }
        }
      }

      .second-line {
        margin: 20px 0;

        > p {
          @include multi-line-ellipsis(2);
          font-size: 30px;
          font-weight: 500;
          color: $secondFontColor;
          line-height: 42px;
        }
      }

      .last-line {
        @include flex-box(space-between);
        margin-bottom: 22px;

        > span:first-child {
          line-height: 40px;
          font-size: 28px;
          color: $baseFontColor;
        }

        > span:last-child {
          line-height: 44px;
          font-size: 32px;
          font-weight: 600;
          color: #fe4600;
        }
      }

      .option-btn {
        @include flex-box(flex-end);
        width: 100%;

        &::v-deep .van-button {
          margin-bottom: 10px;
        }
      }
    }
  }
}
</style>
